const workData = [
    {
        title: "Portfolio",
        description: "Création d'un site web Portfolio sous create-react-app",
        link: "https://github.com/Krozac/krozac.github.io",
        repo: "https://github.com/Krozac/krozac.github.io",
        lang:["ccs","html","js","react.js","three.js"],
        path: "portfolio"
    },
    {
        title: "PeerBox",
        description: "Développement d'un framework js qui simplifie la connection pair a pair et l'architecture ECS pour les jeux multijoueurs",
        link: "https://github.com/Krozac/PeerBox",
        repo : "https://github.com/Krozac/PeerBox",
        lang:["js","typescript","node.js","websocket","vite"],
        path: "peerbox"
    },
    {
        title: "Simulateur",
        description: "Réalisation de differents simulateurs de comportements d'objets",
        link: "https://theoguenezan.fr/simulator-app",
        repo : "https://github.com/Krozac/simulator-app",
        lang:["ccs","html","js","typescript"],
        path: "simulator"
    },    
    {
        title: "Carte Interactive Whiteout survival",
        description: "Création d'une carte interactive open source pour le jeu Whiteout survival",
        link: "https://whiteout-planner.krozac.fr",
        repo : "https://github.com/Krozac/wos-interactive-map",
        lang:["three.js","html","js","css","node.js","mongodb"],
        path: "wosmap"
    },
    {
        title: "Buzz Researcher",
        description: "Application inspirée de Lost Judgment visualisant des posts locaux et des cartes de chaleur de mots-clés sur une carte interactive",
        link: "https://github.com/Krozac/buzz-researcher",
        repo : "https://github.com/Krozac/buzz-researcher",
        lang:["react.js","html","js","css","python","fastapi","leaflet.js","express.js","qgis"],
        path: "buzzresearcher"
    }
];

export default workData;
